import { z } from "zod";
export const userSessionSchema = z.object({
    id: z.string(),
    email: z.string(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    profilePictureUrl: z.string().optional().nullish(),
});
export const organizationSessionSchema = z.object({
    id: z.string(),
    name: z.string(),
    domain: z.string(),
    isActive: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
export const sessionResponseSchema = z.object({
    user: userSessionSchema,
    organization: organizationSessionSchema,
});
